import Immutable from 'immutable';

const LabelModel = Immutable.Record({
	id: 0,
	name: '',
	color: '#999999'
});

export default class Label extends LabelModel {
	id: number;
	name: string;
	color: string;

	static create() {
		return new Label({
			id: 0,
			name: '',
			color: '#999999'
		});
	}
}
